@if (coords()) {
  <div class="map-wrapper">
    <ng-container *uiIfMapProvider="mapProvider.GOOGLE">
      <google-map class="panic-map" [center]="coords()" [zoom]="mapZoom" width="100%" height="100%">
        <map-marker [position]="coords()"></map-marker>
      </google-map>
    </ng-container>
    <ui-maplibre-map
      *uiIfMapProvider="mapProvider.MAPLIBRE"
      class="panic-map"
      [center]="coords()"
      [zoom]="mapZoom"
      [markers]="coords() | uiMapPointMarker"
    ></ui-maplibre-map>
  </div>
} @else if (alert()) {
  <div class="flex-fill center-center empty-text">
    {{ 'GRANTED_ACCESS.PANIC_ALERT.LOCATION_UNAVAILABLE' | translate }}
  </div>
} @else {
  <div class="flex-fill center-center">
    <ui-preloader [color]="loaderColor.blue"></ui-preloader>
  </div>
}
